import { render } from "./App.vue?vue&type=template&id=24f91c56"
const script = {}

import exportComponent from "/builds/anteup/anteup-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__